/**
 * Postadres aanvraag — 3-stappenflow (locatie → pakket + modal → formulier).
 * Leest configuratie uit #postadres-flow-config-<sectionId>.
 */
(function () {
  'use strict';

  // Locatie-UUIDs voor extern systeem (alleen als cart attribute meegegeven).
  var LOCATION_UUIDS = {
    amsterdam: 'ca2b6385-cdf9-46a2-8be2-1b235d769505',
    eindhoven: '30a698c6-7040-4fdd-9a99-541a631b1e63',
    maastricht: 'cfbd058d-9260-4919-9419-ed76b709377c',
  };

  // Shopify variant IDs per locatie + pakkettype.
  // Sleutel: "<locationHandle>:<packageSlug>".
  // packageSlug komt uit het package-block-veld in de section schema.
  var VARIANT_IDS = {
    'amsterdam:start':        57521344545100, // "Amserdam - Start" (typo in title, fix in admin)
    'amsterdam:professional': 57521344577868,
    'amsterdam:business':     57521344610636,
    'eindhoven:start':        57521344643404,
    'eindhoven:professional': 57521344676172,
    'eindhoven:business':     57521344708940,
    'maastricht:start':       57596201107788,
    'maastricht:professional':57596205302092,
    'maastricht:business':    57596206809420,
  };

  var EXTRA_KVK_VERIFICATION_VARIANT_ID = 57896458682700;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getFilledExtraKvkCount(root) {
    var list = qs(root, '[data-repeatable-list="extra_kvk"]');
    if (!list) return 0;
    return qsa(list, 'input[name="extra_kvk"]').filter(function (inp) {
      return String(inp.value || '').trim() !== '';
    }).length;
  }

  function parseEuroNumber(raw) {
    if (raw == null || raw === '') return NaN;
    var s = String(raw)
      .replace(/€/g, '')
      .trim()
      .replace(/\s/g, '');
    s = s.replace(/[^\d,.-]/g, '');
    if (!s) return NaN;
    if (s.indexOf(',') >= 0) {
      s = s.replace(/\./g, '').replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  function formatEuroDutch(num) {
    if (num == null || isNaN(num)) return '';
    var rounded = Math.round(num * 100) / 100;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-6) {
      return '€ ' + Math.round(rounded) + ',-';
    }
    return '€ ' + rounded.toFixed(2).replace('.', ',');
  }

  function parseConfig(scriptEl) {
    if (!scriptEl || !scriptEl.textContent) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('postadres-aanvraag-flow: invalid JSON config', e);
      return null;
    }
  }

  function applyAddonToEuroValues(text, addon) {
    var baseText = String(text || '');
    var delta = Number(addon) || 0;
    if (!baseText.trim() || delta <= 0) return baseText;
    return baseText.replace(/€\s*[0-9][0-9.,-]*/g, function (rawMatch) {
      var parsed = parseEuroNumber(rawMatch);
      if (isNaN(parsed)) return rawMatch;
      return formatEuroDutch(parsed + delta).replace('€ ', '€');
    });
  }

  function getTodayIsoLocal() {
    var now = new Date();
    var y = now.getFullYear();
    var m = String(now.getMonth() + 1).padStart(2, '0');
    var d = String(now.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  var phoneCountriesCache = null;
  var phoneCountriesFetchPromise = null;

  function phoneFlagAssetUrl(iso) {
    var i = String(iso || 'nl').toLowerCase();
    var map = { ac: 'sh', ta: 'sh' };
    var code = map[i] || i;
    return 'https://flagcdn.com/w40/' + code + '.png';
  }

  function syncPhoneFlagImg(flagImg, iso) {
    if (!flagImg) return;
    flagImg.src = phoneFlagAssetUrl(iso);
  }

  function getPhoneMetaByIso(iso, countries) {
    var list = countries || phoneCountriesCache || [];
    var want = String(iso || 'nl').toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].i).toLowerCase() === want) {
        return { iso: String(list[i].i).toLowerCase(), dial: String(list[i].d) };
      }
    }
    return { iso: 'nl', dial: '31' };
  }

  function extractDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function buildPhoneWithDial(value, dial, iso, prevDial) {
    var d = String(dial || '31');
    var digits = extractDigits(value);
    if (prevDial && digits.indexOf(String(prevDial)) === 0) {
      digits = digits.slice(String(prevDial).length);
    }
    if (digits.indexOf(d) === 0) {
      digits = digits.slice(d.length);
    }
    if (String(iso || '').toLowerCase() === 'nl' && digits.indexOf('0') === 0) {
      digits = digits.slice(1);
    }
    return '+' + d + ' ' + digits;
  }

  function phoneNationalDigitCount(value, dial) {
    var d = String(dial || '31');
    var digits = extractDigits(value);
    if (digits.indexOf(d) === 0) digits = digits.slice(d.length);
    return digits.length;
  }

  function syncPhoneInputWithDial(phoneInput, dial, iso, prevDial) {
    if (!phoneInput) return;
    phoneInput.value = buildPhoneWithDial(phoneInput.value, dial, iso, prevDial);
  }

  function syncPhoneDialPrefix(prefixEl, select, countries) {
    var meta = getPhoneMetaByIso(select && select.value, countries);
    if (prefixEl) prefixEl.textContent = '+' + meta.dial;
    if (select) {
      select.setAttribute('data-current-dial', meta.dial);
      select.setAttribute('data-current-iso', meta.iso);
    }
    return meta;
  }

  function populatePhoneCountrySelect(select, flagImg, prefixEl, countries, preferredIso) {
    preferredIso = String(preferredIso || 'nl').toLowerCase();
    select.innerHTML = '';
    countries.forEach(function (row) {
      var iso = String(row.i).toLowerCase();
      var opt = document.createElement('option');
      opt.value = iso;
      opt.textContent = row.n + ' (+' + row.d + ')';
      select.appendChild(opt);
    });
    var pick = countries.some(function (r) {
      return String(r.i).toLowerCase() === preferredIso;
    })
      ? preferredIso
      : 'nl';
    select.value = pick;
    syncPhoneFlagImg(flagImg, select.value);
    syncPhoneDialPrefix(prefixEl, select, countries);
  }

  function wirePhoneCountryChange(select, flagImg, prefixEl, phoneInput, countries) {
    if (select.getAttribute('data-postadres-phone-wired') === '1') return;
    select.setAttribute('data-postadres-phone-wired', '1');
    select.addEventListener('change', function () {
      var prevDial = select.getAttribute('data-current-dial') || '31';
      syncPhoneFlagImg(flagImg, select.value);
      var meta = syncPhoneDialPrefix(prefixEl, select, countries);
      syncPhoneInputWithDial(phoneInput, meta.dial, meta.iso, prevDial);
    });
  }

  function ensurePhoneCountries(url) {
    if (phoneCountriesCache) return Promise.resolve(phoneCountriesCache);
    if (phoneCountriesFetchPromise) return phoneCountriesFetchPromise;
    phoneCountriesFetchPromise = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('phone countries');
        return r.json();
      })
      .then(function (data) {
        phoneCountriesCache = data;
        return data;
      })
      .catch(function (err) {
        phoneCountriesFetchPromise = null;
        throw err;
      });
    return phoneCountriesFetchPromise;
  }

  function initPhoneCountryRow(section, config) {
    qsa(section, '[data-phone-row]').forEach(function (row) {
      var select = qs(row, '[data-phone-cc]');
      var flagImg = qs(row, '[data-phone-flag]');
      var prefixEl = qs(row, '[data-phone-prefix]');
      var phoneInput = qs(row, '[name="phone"]');
      if (!select || !flagImg) return;

      function apply(data) {
        if (!Array.isArray(data)) return;
        var pref = (
          select.getAttribute('data-default-iso') ||
          select.value ||
          'nl'
        ).toLowerCase();
        populatePhoneCountrySelect(select, flagImg, prefixEl, data, pref);
        var meta = syncPhoneDialPrefix(prefixEl, select, data);
        syncPhoneInputWithDial(phoneInput, meta.dial, meta.iso);
        wirePhoneCountryChange(select, flagImg, prefixEl, phoneInput, data);
      }

      var url = config.phoneCountriesUrl;
      if (phoneCountriesCache) {
        apply(phoneCountriesCache);
        return;
      }
      if (!url) {
        var fallbackMeta = syncPhoneDialPrefix(prefixEl, select);
        syncPhoneInputWithDial(phoneInput, fallbackMeta.dial, fallbackMeta.iso);
        wirePhoneCountryChange(select, flagImg, prefixEl, phoneInput);
        syncPhoneFlagImg(flagImg, select.value || 'nl');
        return;
      }
      ensurePhoneCountries(url)
        .then(function (data) {
          apply(data);
        })
        .catch(function () {
          var fallbackMeta = syncPhoneDialPrefix(prefixEl, select);
          syncPhoneInputWithDial(phoneInput, fallbackMeta.dial, fallbackMeta.iso);
          wirePhoneCountryChange(select, flagImg, prefixEl, phoneInput);
          syncPhoneFlagImg(flagImg, select.value || 'nl');
        });
    });
  }

  function resetPostadresPhoneRow(form) {
    var row = qs(form, '[data-phone-row]');
    if (!row || !phoneCountriesCache) return;
    var select = qs(row, '[data-phone-cc]');
    var flagImg = qs(row, '[data-phone-flag]');
    var prefixEl = qs(row, '[data-phone-prefix]');
    if (!select || !flagImg) return;
    populatePhoneCountrySelect(select, flagImg, prefixEl, phoneCountriesCache, 'nl');
  }

  function isValidEmailValue(value) {
    var v = String(value || '').trim();
    if (!v) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function sanitizePhoneValue(value, dial, iso, prevDial) {
    return buildPhoneWithDial(value, dial, iso, prevDial).slice(0, 24);
  }

  function sanitizeHouseNumberValue(value) {
    var raw = String(value || '');
    var out = raw.replace(/[^0-9A-Za-z\s\-/]/g, '');
    return out.slice(0, 10).trimStart();
  }

function sanitizePostcodeValue(value) {
  var compact = String(value || '').toUpperCase().replace(/[^0-9A-Z]/g, '');

  // NL: max 6 tekens zonder spatie, BE/DE: 4 of 5 cijfers
  if (compact.length > 6) compact = compact.slice(0, 6);

  // Alleen cijfers = BE/DE, geen spatie toevoegen
  if (/^[0-9]+$/.test(compact)) return compact;

  // NL postcode formatteren als 1234 AB
  if (compact.length <= 4) return compact;
  return compact.slice(0, 4) + ' ' + compact.slice(4);
}

function isValidPostcode(value) {
  var normalized = String(value || '').toUpperCase().replace(/\s/g, '');

  // Nederland: 1234AB
  if (/^[1-9][0-9]{3}[A-Z]{2}$/.test(normalized)) return true;

  // België: 1000
  if (/^[0-9]{4}$/.test(normalized)) return true;

  // Duitsland: 10115
  if (/^[0-9]{5}$/.test(normalized)) return true;

  return false;
}

  function sanitizeKvkValue(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function isValidKvkValue(value) {
    var v = sanitizeKvkValue(value);
    if (!v) return true;
    return /^[0-9]{8}$/.test(v);
  }

  function syncKvkInputValidity(input) {
    if (!input) return true;
    var cleaned = sanitizeKvkValue(input.value);
    if (cleaned !== input.value) input.value = cleaned;
    if (isValidKvkValue(cleaned)) {
      input.setCustomValidity('');
      return true;
    }
    input.setCustomValidity('Vul een geldig KVK-nummer in (8 cijfers, alleen cijfers).');
    return false;
  }

  function validateAllKvkInputs(form) {
    var kvkInput = qs(form, '[name="kvk_number"]');
    if (kvkInput && !syncKvkInputValidity(kvkInput)) {
      kvkInput.reportValidity();
      return false;
    }
    var extraInputs = qsa(form, 'input[name="extra_kvk"]');
    for (var i = 0; i < extraInputs.length; i++) {
      if (!syncKvkInputValidity(extraInputs[i])) {
        extraInputs[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  function sanitizeNameValue(value, options) {
    var raw = String(value || '');
    var out = raw.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ'\-\s]/g, '');
    var keepEdgeSpaces = !!(options && options.keepEdgeSpaces);
    if (keepEdgeSpaces) {
      out = out.replace(/\s{2,}/g, ' ');
    } else {
      out = out.replace(/\s+/g, ' ').trim();
    }
    return out.slice(0, 50);
  }

  function isValidNameValue(value) {
    var v = sanitizeNameValue(value);
    return /^[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ'\-\s]{0,49}$/.test(v);
  }

  function initStrictContactValidation(form) {
    var todayIso = getTodayIsoLocal();
    var firstNameInput = qs(form, '[name="first_name"]');
    if (firstNameInput) {
      var syncFirstNameValidity = function () {
        var cleaned = sanitizeNameValue(firstNameInput.value);
        if (cleaned !== firstNameInput.value) firstNameInput.value = cleaned;
        if (!cleaned || isValidNameValue(cleaned)) {
          firstNameInput.setCustomValidity('');
          return;
        }
        firstNameInput.setCustomValidity('Vul een geldige voornaam in.');
      };
      firstNameInput.addEventListener('input', syncFirstNameValidity);
      firstNameInput.addEventListener('blur', syncFirstNameValidity);
    }

    var lastNameInput = qs(form, '[name="last_name"]');
    if (lastNameInput) {
      var syncLastNameValidity = function () {
        var cleaned = sanitizeNameValue(lastNameInput.value, { keepEdgeSpaces: true });
        if (cleaned !== lastNameInput.value) lastNameInput.value = cleaned;
        if (!cleaned.trim() || isValidNameValue(cleaned)) {
          lastNameInput.setCustomValidity('');
          return;
        }
        lastNameInput.setCustomValidity('Vul een geldige achternaam in.');
      };
      lastNameInput.addEventListener('input', syncLastNameValidity);
      lastNameInput.addEventListener('blur', syncLastNameValidity);
    }

    var emailInput = qs(form, '[name="email"]');
    if (emailInput) {
      var syncEmailValidity = function () {
        var value = String(emailInput.value || '').trim();
        if (!value || isValidEmailValue(value)) {
          emailInput.setCustomValidity('');
          return;
        }
        emailInput.setCustomValidity('Vul een geldig e-mailadres in.');
      };
      emailInput.addEventListener('input', syncEmailValidity);
      emailInput.addEventListener('blur', syncEmailValidity);
    }

    var phoneInput = qs(form, '[name="phone"]');
    if (phoneInput) {
      var syncPhoneValidity = function () {
        var select = qs(form, '[name="phone_country"]');
        var meta = syncPhoneDialPrefix(null, select);
        var cleaned = sanitizePhoneValue(phoneInput.value, meta.dial, meta.iso, meta.dial);
        if (cleaned !== phoneInput.value) phoneInput.value = cleaned;
        var digitCount = phoneNationalDigitCount(cleaned, meta.dial);
        if (!cleaned || digitCount >= 6) {
          phoneInput.setCustomValidity('');
          return;
        }
        phoneInput.setCustomValidity('Vul een geldig telefoonnummer in (minimaal 6 cijfers).');
      };
      phoneInput.addEventListener('input', syncPhoneValidity);
      phoneInput.addEventListener('blur', syncPhoneValidity);
    }

    var houseNumberInput = qs(form, '[name="house_number"]');
    if (houseNumberInput) {
      var syncHouseNumberValidity = function () {
        var cleaned = sanitizeHouseNumberValue(houseNumberInput.value);
        if (cleaned !== houseNumberInput.value) houseNumberInput.value = cleaned;
        if (!cleaned) {
          houseNumberInput.setCustomValidity('');
          return;
        }
        houseNumberInput.setCustomValidity('');
      };
      houseNumberInput.addEventListener('input', syncHouseNumberValidity);
      houseNumberInput.addEventListener('blur', syncHouseNumberValidity);
    }

    var postcodeInput = qs(form, '[name="postcode"]');
    if (postcodeInput) {
      var syncPostcodeValidity = function () {
        var cleaned = sanitizePostcodeValue(postcodeInput.value);
        if (cleaned !== postcodeInput.value) postcodeInput.value = cleaned;
        if (!cleaned || isValidPostcode(cleaned)) {
          postcodeInput.setCustomValidity('');
          return;
        }
        postcodeInput.setCustomValidity('Vul een geldige postcode in.');
      };
      postcodeInput.addEventListener('input', syncPostcodeValidity);
      postcodeInput.addEventListener('blur', syncPostcodeValidity);
    }

    var birthDateInput = qs(form, '[name="birth_date"]');
    if (birthDateInput) {
      var syncBirthDateMax = function () {
        birthDateInput.setAttribute('max', getTodayIsoLocal());
      };
      syncBirthDateMax();
      var syncBirthDateValidity = function () {
        var maxToday = getTodayIsoLocal();
        var value = String(birthDateInput.value || '');
        if (!value || value <= maxToday) {
          birthDateInput.setCustomValidity('');
          return;
        }
        birthDateInput.setCustomValidity('Geboortedatum kan niet in de toekomst liggen.');
      };
      birthDateInput.addEventListener('focus', syncBirthDateMax);
      birthDateInput.addEventListener('click', syncBirthDateMax);
      birthDateInput.addEventListener('change', syncBirthDateValidity);
      birthDateInput.addEventListener('blur', syncBirthDateValidity);
    }

    var kvkInput = qs(form, '[name="kvk_number"]');
    if (kvkInput) {
      var syncMainKvkValidity = function () {
        syncKvkInputValidity(kvkInput);
      };
      kvkInput.addEventListener('input', syncMainKvkValidity);
      kvkInput.addEventListener('blur', syncMainKvkValidity);
    }

    form.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || t.name !== 'extra_kvk') return;
      syncKvkInputValidity(t);
    });
    form.addEventListener('blur', function (e) {
      var t = e.target;
      if (!t || t.name !== 'extra_kvk') return;
      syncKvkInputValidity(t);
    }, true);
  }

  var postadresSidebarHeaderSyncDone = false;

  function siteHeaderIsRevealedSticky() {
    var h = document.querySelector('.shopify-section-header');
    if (!h) return false;
    if (h.classList.contains('shopify-section-header-hidden')) return false;
    if (h.classList.contains('shopify-section-header-sticky')) return true;
    if (h.classList.contains('shopify-section-header-always-sticky')) return true;
    return false;
  }

  function syncPostadresSidebarStackWithSiteHeader() {
    var revealed = siteHeaderIsRevealedSticky();
    qsa(document, '.postadres-flow__sidebar-stack').forEach(function (el) {
      el.classList.toggle('postadres-flow__sidebar-stack--site-header-revealed', revealed);
    });
  }

  function initPostadresSidebarHeaderSync() {
    if (postadresSidebarHeaderSyncDone) return;
    var header = document.querySelector('.shopify-section-header');
    if (!header) return;
    postadresSidebarHeaderSyncDone = true;
    var obs = new MutationObserver(syncPostadresSidebarStackWithSiteHeader);
    obs.observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', syncPostadresSidebarStackWithSiteHeader, { passive: true });
    syncPostadresSidebarStackWithSiteHeader();
  }

  function initSection(section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    var configScript = document.getElementById('postadres-flow-config-' + sectionId);
    var config = parseConfig(configScript);
    if (!config) return;

    var panels = {
      1: qs(section, '[data-step-panel="1"]'),
      2: qs(section, '[data-step-panel="2"]'),
      3: qs(section, '[data-step-panel="3"]'),
    };

    var stepperItems = qsa(section, '[data-stepper-step]');
    var modal = qs(section, '.postadres-flow__modal');
    var modalBackdrop = qs(section, '.postadres-flow__modal-backdrop');
    var modalBody = qs(section, '.postadres-flow__modal-body');
    var modalClose = qsa(section, '[data-modal-close]');
    var modalCta = qs(section, '[data-modal-cta]');

    var state = {
      step: 1,
      location: null,
      packageId: null,
    };
    var mobileSheet = {
      enabled: false,
      expanded: false,
      collapseTimer: null,
      collapseEndHandler: null,
    };

    function canNavigateToStep(target) {
      if (target === 1) return true;
      if (target === 2) return !!state.location;
      if (target === 3) return !!state.location && !!state.packageId;
      return false;
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function setMobileSheetExpanded(expanded) {
      var stack = qs(section, '[data-mobile-step3-sheet]');
      var sidebar = qs(section, '.postadres-flow__sidebar');
      if (!stack || !mobileSheet.enabled) return;
      if (mobileSheet.collapseTimer) {
        clearTimeout(mobileSheet.collapseTimer);
        mobileSheet.collapseTimer = null;
      }
      if (sidebar && mobileSheet.collapseEndHandler) {
        sidebar.removeEventListener('transitionend', mobileSheet.collapseEndHandler);
        mobileSheet.collapseEndHandler = null;
      }
      mobileSheet.expanded = !!expanded;
      if (mobileSheet.expanded) {
        stack.classList.remove('is-collapsing');
        stack.classList.add('is-expanded');
      } else {
        stack.classList.remove('is-expanded');
        stack.classList.add('is-collapsing');
        var finalizeCollapse = function () {
          stack.classList.remove('is-collapsing');
          if (sidebar && mobileSheet.collapseEndHandler) {
            sidebar.removeEventListener('transitionend', mobileSheet.collapseEndHandler);
            mobileSheet.collapseEndHandler = null;
          }
          if (mobileSheet.collapseTimer) {
            clearTimeout(mobileSheet.collapseTimer);
          }
          mobileSheet.collapseTimer = null;
        };
        if (sidebar) {
          mobileSheet.collapseEndHandler = function (e) {
            if (e.target !== sidebar) return;
            finalizeCollapse();
          };
          sidebar.addEventListener('transitionend', mobileSheet.collapseEndHandler);
        }
        mobileSheet.collapseTimer = setTimeout(finalizeCollapse, 500);
      }
      stack.classList.remove('is-dragging');
      if (sidebar) sidebar.style.transform = '';
      var lock = mobileSheet.expanded && state.step === 3 && isMobileViewport();
      document.documentElement.classList.toggle('postadres-flow-sheet-open', lock);
    }

    function syncMobileStep3SheetState() {
      var stack = qs(section, '[data-mobile-step3-sheet]');
      var sidebar = qs(section, '.postadres-flow__sidebar');
      if (!stack) return;
      var shouldEnable = state.step === 3 && isMobileViewport();
      mobileSheet.enabled = shouldEnable;
      stack.classList.toggle('postadres-flow__sidebar-stack--mobile-sheet-enabled', shouldEnable);
      if (!shouldEnable) {
        if (mobileSheet.collapseTimer) {
          clearTimeout(mobileSheet.collapseTimer);
          mobileSheet.collapseTimer = null;
        }
        if (sidebar && mobileSheet.collapseEndHandler) {
          sidebar.removeEventListener('transitionend', mobileSheet.collapseEndHandler);
          mobileSheet.collapseEndHandler = null;
        }
        mobileSheet.expanded = false;
        stack.classList.remove('is-expanded');
        stack.classList.remove('is-collapsing');
        stack.classList.remove('is-dragging');
        if (sidebar) sidebar.style.transform = '';
        document.documentElement.classList.remove('postadres-flow-sheet-open');
      }
    }

    function initMobileStep3Sheet() {
      var stack = qs(section, '[data-mobile-step3-sheet]');
      var sidebar = qs(section, '.postadres-flow__sidebar');
      var dragHandle = qs(section, '[data-mobile-sheet-drag]');
      var tab = qs(section, '[data-mobile-sheet-tab]');
      var handleBtn = qs(section, '[data-mobile-sheet-toggle]');
      var nextBtn = qs(section, '[data-mobile-sheet-next]');
      var backdropBtn = qs(section, '[data-mobile-sheet-backdrop]');
      if (!stack || !sidebar || !tab || !handleBtn) return;

      function bindOpenSwipe(el) {
        var startY = 0;
        var tracking = false;
        el.addEventListener(
          'touchstart',
          function (e) {
            if (!mobileSheet.enabled || mobileSheet.expanded) return;
            if (!e.touches || e.touches.length !== 1) return;
            startY = e.touches[0].clientY;
            tracking = true;
          },
          { passive: true }
        );
        el.addEventListener(
          'touchmove',
          function (e) {
            if (!tracking || !e.touches || !e.touches.length) return;
            var dy = e.touches[0].clientY - startY;
            if (dy < 0) e.preventDefault();
          },
          { passive: false }
        );
        el.addEventListener(
          'touchend',
          function (e) {
            if (!tracking || !e.changedTouches || !e.changedTouches.length) return;
            var dy = e.changedTouches[0].clientY - startY;
            tracking = false;
            if (dy < -24) setMobileSheetExpanded(true);
          },
          { passive: true }
        );
      }

      function bindCloseDrag(el) {
        var startY = 0;
        var dragY = 0;
        var tracking = false;
        function stopDrag(shouldClose) {
          tracking = false;
          stack.classList.remove('is-dragging');
          if (shouldClose) {
            setMobileSheetExpanded(false);
            return;
          }
          sidebar.style.transform = '';
        }
        el.addEventListener(
          'touchstart',
          function (e) {
            if (!mobileSheet.enabled || !mobileSheet.expanded) return;
            if (!e.touches || e.touches.length !== 1) return;
            var startTarget = e.target;
            if (
              startTarget &&
              startTarget.closest &&
              startTarget.closest('button, a, input, select, textarea, label')
            ) {
              return;
            }
            if (sidebar.scrollTop > 0) return;
            startY = e.touches[0].clientY;
            dragY = 0;
            tracking = true;
            stack.classList.add('is-dragging');
          },
          { passive: true }
        );
        el.addEventListener(
          'touchmove',
          function (e) {
            if (!tracking || !e.touches || !e.touches.length) return;
            var dy = e.touches[0].clientY - startY;
            if (dy <= 0) {
              dragY = 0;
              sidebar.style.transform = '';
              return;
            }
            dragY = dy;
            sidebar.style.transform = 'translateY(' + dy + 'px)';
            e.preventDefault();
          },
          { passive: false }
        );
        el.addEventListener(
          'touchend',
          function () {
            if (!tracking) return;
            stopDrag(dragY > 90);
          },
          { passive: true }
        );
        el.addEventListener(
          'touchcancel',
          function () {
            if (!tracking) return;
            stopDrag(false);
          },
          { passive: true }
        );
      }

      handleBtn.addEventListener('click', function () {
        if (!mobileSheet.enabled) return;
        setMobileSheetExpanded(!mobileSheet.expanded);
      });
      if (backdropBtn) {
        backdropBtn.addEventListener('click', function () {
          if (!mobileSheet.enabled || !mobileSheet.expanded) return;
          setMobileSheetExpanded(false);
        });
      }
      tab.addEventListener('click', function () {
        if (!mobileSheet.enabled || mobileSheet.expanded) return;
        setMobileSheetExpanded(true);
      });
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          if (e && e.stopPropagation) e.stopPropagation();
          if (!mobileSheet.enabled) return;
          var accordions = qsa(section, '.postadres-flow__accordion');
          if (isMobileViewport()) {
            var mobileForm = qs(section, '[data-postadres-form]');
            if (mobileForm && !validateDeliveryYesNoChoice(mobileForm, true)) {
              return;
            }
            if (mobileForm && !mobileForm.checkValidity()) {
              focusInvalidField(mobileForm);
              return;
            }
            setMobileSheetExpanded(true);
            return;
          }
          if (accordions.length >= 2 && !accordions[1].open) {
            moveToDetailsAccordion();
            return;
          }
          var form = qs(section, '[data-postadres-form]');
          if (!form) return;
          if (!validateDeliveryYesNoChoice(form, true)) {
            return;
          }
          if (!form.checkValidity()) {
            focusInvalidField(form);
            return;
          }
          section.dispatchEvent(
            new CustomEvent('postadresflow:next-intent', {
              detail: { step: state.step, state: state },
            })
          );
        });
      }
      bindOpenSwipe(tab);
      bindOpenSwipe(handleBtn);
      if (sidebar) {
        bindCloseDrag(sidebar);
      } else if (dragHandle) {
        bindCloseDrag(dragHandle);
      }
      window.addEventListener('resize', syncMobileStep3SheetState);
    }

    function updateStepperNavigability() {
      stepperItems.forEach(function (el) {
        var n = parseInt(el.getAttribute('data-stepper-step'), 10);
        if (isNaN(n)) return;
        var ok = canNavigateToStep(n);
        el.classList.toggle('is-navigable', ok);
        el.classList.toggle('is-locked', !ok);
        el.setAttribute('aria-disabled', ok ? 'false' : 'true');
        el.setAttribute('tabindex', ok ? '0' : '-1');
        el.setAttribute('role', 'button');
      });
    }

    function tryGoToStep(n) {
      if (!canNavigateToStep(n)) return;
      setStep(n);
    }

    function scrollFlowToTop() {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        try {
          window.scrollTo(0, 0);
        } catch (e2) {
          /* ignore */
        }
      }
    }

    function setStep(n) {
      var prevStep = state.step;
      if (modal && !modal.hidden) closeModal();
      state.step = n;
      Object.keys(panels).forEach(function (k) {
        var p = panels[k];
        if (!p) return;
        var active = String(n) === k;
        p.hidden = !active;
        p.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      stepperItems.forEach(function (el) {
        var s = parseInt(el.getAttribute('data-stepper-step'), 10);
        el.classList.toggle('is-active', s === n);
        el.classList.toggle('is-complete', s < n);
      });
      if (n === 2) {
        syncStep2Header();
        filterPackages();
        syncStep2PackageInfo();
      }
      if (n === 3) {
        var activePkg = getPackageById(state.packageId);
        syncStep3Sidebar();
        syncStep3DeliverySection(activePkg);
        var step3Panel = panels[3];
        if (step3Panel) {
          var step3Accordions = qsa(step3Panel, '.postadres-flow__accordion').filter(function (acc) {
            return !acc.hidden;
          });
          if (step3Accordions.length >= 1) {
            if (isMobileViewport()) {
              step3Accordions.forEach(function (acc) {
                acc.open = true;
              });
            } else {
              step3Accordions[0].open = true;
              for (var i = 1; i < step3Accordions.length; i++) {
                step3Accordions[i].open = false;
              }
            }
          }
        }
      }
      syncMobileStep3SheetState();
      section.dispatchEvent(
        new CustomEvent('postadresflow:step', { detail: { step: n, state: state } })
      );
      updateStepperNavigability();
      if (prevStep !== n) {
        requestAnimationFrame(function () {
          scrollFlowToTop();
        });
      }
    }

    function moveToDetailsAccordion() {
      var detailsAccordion = qs(section, '[data-details-accordion]');
      var deliveryAccordion = qs(section, '[data-delivery-accordion]');
      if (!detailsAccordion) return false;
      if (isMobileViewport()) {
        if (deliveryAccordion && !deliveryAccordion.hidden) deliveryAccordion.open = true;
        detailsAccordion.open = true;
      } else {
        if (deliveryAccordion && !deliveryAccordion.hidden) deliveryAccordion.open = false;
        detailsAccordion.open = true;
      }
      var focusInput = qs(detailsAccordion, 'input, textarea, select');
      if (focusInput && focusInput.focus) focusInput.focus();
      requestAnimationFrame(function () {
        if (isMobileViewport()) {
          try {
            var targetTop =
              detailsAccordion.getBoundingClientRect().top + window.pageYOffset - 16;
            window.scrollTo({
              top: Math.max(0, targetTop),
              behavior: 'smooth',
            });
          } catch (e) {
            scrollFlowToTop();
          }
        } else {
          scrollFlowToTop();
        }
      });
      return true;
    }

    function focusInvalidField(form) {
      if (!form) return false;
      var invalid = qs(form, ':invalid');
      if (!invalid) return false;
      var parentAccordion = invalid.closest('.postadres-flow__accordion');
      if (parentAccordion) parentAccordion.open = true;
      requestAnimationFrame(function () {
        try {
          var targetTop = invalid.getBoundingClientRect().top + window.pageYOffset - 20;
          window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
        } catch (e) {
          /* ignore */
        }
        try {
          if (invalid.focus) invalid.focus({ preventScroll: true });
        } catch (e2) {
          if (invalid.focus) invalid.focus();
        }
        if (invalid.reportValidity) invalid.reportValidity();
      });
      return true;
    }

    function validateDeliveryYesNoChoice(form, shouldReport) {
      if (!form) return true;
      var deliveryAccordion = qs(section, '[data-delivery-accordion]');
      if (deliveryAccordion && deliveryAccordion.hidden) return true;
      var radios = qsa(form, 'input[type="radio"][name="delivery[]"]');
      if (!radios.length) return true;
      var selected = radios.some(function (radio) {
        return !!radio.checked;
      });
      var firstRadio = radios[0];
      firstRadio.setCustomValidity(selected ? '' : 'Maak een keuze.');
      if (selected) return true;
      if (deliveryAccordion) deliveryAccordion.open = true;
      if (shouldReport) {
        requestAnimationFrame(function () {
          try {
            var targetTop = firstRadio.getBoundingClientRect().top + window.pageYOffset - 20;
            window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
          } catch (e) {
            /* ignore */
          }
          if (firstRadio.focus) firstRadio.focus();
          if (firstRadio.reportValidity) firstRadio.reportValidity();
        });
      }
      return false;
    }

    function normLocHandle(h) {
      if (h == null) return '';
      return String(h).trim().toLowerCase();
    }

    function getLocationByHandle(handle) {
      var want = normLocHandle(handle);
      return (config.locations || []).find(function (l) {
        return normLocHandle(l.handle) === want;
      });
    }

    function getPackageById(id) {
      return (config.packages || {})[id];
    }

    function syncStep2Header() {
      var loc = getLocationByHandle(state.location);
      var titleEl = qs(section, '[data-step2-address-title]');
      var subEl = qs(section, '[data-step2-address-sub]');
      var imgEl = qs(section, '.postadres-flow__hero-img');
      if (!loc) return;
      if (titleEl) titleEl.textContent = loc.addressLine1 || '';
      if (subEl) {
        var parts = [loc.addressLine2, loc.city].filter(Boolean);
        subEl.textContent = parts.join(' - ');
      }
      if (imgEl) {
        if (loc.image) {
          imgEl.src = loc.image;
          imgEl.alt = loc.city || '';
          imgEl.hidden = false;
        } else {
          imgEl.hidden = true;
        }
      }
    }

    function textFromHtml(html) {
      if (html == null || html === '') return '';
      var d = document.createElement('div');
      d.innerHTML = String(html);
      return (d.textContent || '').replace(/\s+/g, ' ').trim();
    }

    function syncStep2PackageInfo() {
      var wrap = qs(section, '[data-step2-package-info]');
      var c1 = qs(section, '[data-step2-info-col="1"]');
      var c2 = qs(section, '[data-step2-info-col="2"]');
      if (!wrap || !c1 || !c2) return;
      var loc = getLocationByHandle(state.location);
      var fb = config.packageInfoFallback || {};
      function pick(locKey, fbKey) {
        var v = loc && loc[locKey];
        if (v != null && String(v).trim() !== '') return v;
        var f = fb[fbKey];
        return f != null && String(f).trim() !== '' ? f : '';
      }
      var h1 = pick('infoText1', 'col1');
      var h2 = pick('infoText2', 'col2');
      c1.innerHTML = h1;
      c2.innerHTML = h2;
      var has1 = textFromHtml(h1).length > 0;
      var has2 = textFromHtml(h2).length > 0;
      c1.hidden = !has1;
      c2.hidden = !has2;
      wrap.hidden = !has1 && !has2;
    }

    function filterPackages() {
      var sel = normLocHandle(state.location);
      qsa(section, '[data-package-card]').forEach(function (card) {
        var loc = normLocHandle(card.getAttribute('data-location-handle'));
        var show = !sel || loc === sel;
        card.hidden = !show;
      });
    }

    function escapeHtml(str) {
      if (str == null || str === '') return '';
      var d = document.createElement('div');
      d.textContent = str;
      return d.innerHTML;
    }

    function escapeAttr(str) {
      if (str == null || str === '') return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;');
    }

    function setSidebarMoneyMarkup(el, raw) {
      if (!el) return;
      var s = raw == null ? '' : String(raw).trim();
      if (!s) {
        el.textContent = '';
        return;
      }
      var sym = '€';
      var idx = s.indexOf(sym);
      if (idx === -1) idx = s.indexOf('\u20AC');
      if (idx !== -1) {
        var cur = s.slice(0, idx + 1);
        var rest = s.slice(idx + 1).replace(/^\s+/, '');
        el.innerHTML =
          '<span class="postadres-flow__sidebar-currency">' +
          escapeHtml(cur) +
          '</span> <span class="postadres-flow__sidebar-amount">' +
          escapeHtml(rest) +
          '</span>';
        return;
      }
      el.textContent = s;
    }

    function modalIconHtml(url) {
      if (!url)
        return '<span class="postadres-flow__modal-row-icon-spacer" aria-hidden="true"></span>';
      return (
        '<img class="postadres-flow__modal-row-icon" src="' +
        escapeAttr(url) +
        '" alt="" width="24" height="24" loading="lazy">'
      );
    }

    function setSectionVisible(sectionEl, visible) {
      if (sectionEl) sectionEl.hidden = !visible;
    }

    function fillModal(pkg) {
      if (!pkg) return;
      var titleNode = qs(section, '[data-modal-title-text]');
      if (titleNode) {
        titleNode.textContent = pkg.modalTitle || config.defaultModalTitle || '';
      }
      if (!modalBody) return;

      var inc = qs(modalBody, '[data-modal-included]');
      var opt = qs(modalBody, '[data-modal-optional]');
      var reg = qs(modalBody, '[data-modal-registration]');
      var note = qs(modalBody, '[data-modal-footnote]');
      var secInc = qs(modalBody, '[data-modal-section="included"]');
      var secReg = qs(modalBody, '[data-modal-section="registration"]');
      var secOpt = qs(modalBody, '[data-modal-section="optional"]');
      var optStack = qs(modalBody, '[data-modal-optional-stack]');
      var optTitle = secOpt ? qs(secOpt, '.postadres-flow__modal-section-title') : null;

      if (inc) {
        var incRows = pkg.modalIncludedRows;
        if (incRows && incRows.length) {
          inc.innerHTML = incRows
            .map(function (row) {
              return (
                '<div class="postadres-flow__modal-line">' +
                modalIconHtml(row.icon) +
                (row.text
                  ? '<span class="postadres-flow__modal-row-label">' +
                    escapeHtml(row.text) +
                    '</span>'
                  : '') +
                '</div>'
              );
            })
            .join('');
        } else if (pkg.modalIncluded) {
          inc.innerHTML = pkg.modalIncluded;
        } else {
          inc.innerHTML = '';
        }
        setSectionVisible(secInc, !!inc.innerHTML.trim());
      }

      if (reg) {
        var mr = pkg.modalReg;
        var oneTimeRows = [];
        if (mr && (mr.label || mr.price || mr.icon)) {
          oneTimeRows.push({
            text: mr.label,
            icon: mr.icon,
            price: mr.price,
            suffix: mr.suffix,
          });
        }
        var extraOneTimeRows = pkg.modalOneTimeRows || [];
        if (extraOneTimeRows && extraOneTimeRows.length) {
          oneTimeRows = oneTimeRows.concat(extraOneTimeRows);
        }
        if (oneTimeRows.length) {
          reg.innerHTML = oneTimeRows
            .map(function (row) {
              return (
                '<div class="postadres-flow__modal-line postadres-flow__modal-line--split">' +
                '<div class="postadres-flow__modal-line-start">' +
                modalIconHtml(row.icon) +
                (row.text
                  ? '<span class="postadres-flow__modal-row-label">' +
                    escapeHtml(row.text) +
                    '</span>'
                  : '') +
                '</div>' +
                '<div class="postadres-flow__modal-line-price">' +
                (row.price
                  ? '<strong class="postadres-flow__modal-price-main">' +
                    escapeHtml(row.price) +
                    '</strong>'
                  : '') +
                (row.suffix
                  ? '<span class="postadres-flow__modal-price-suffix">' +
                    escapeHtml(row.suffix) +
                    '</span>'
                  : '') +
                '</div></div>'
              );
            })
            .join('');
        } else if (pkg.modalRegistrationLegacy) {
          reg.innerHTML = pkg.modalRegistrationLegacy;
        } else {
          reg.innerHTML = '';
        }
        setSectionVisible(secReg, !!reg.innerHTML.trim());
      }

      if (opt) {
        var optRows = pkg.modalOptionalRows;
        if (optRows && optRows.length) {
          opt.innerHTML = optRows
            .map(function (row) {
              return (
                '<div class="postadres-flow__modal-line postadres-flow__modal-line--split">' +
                '<div class="postadres-flow__modal-line-start">' +
                modalIconHtml(row.icon) +
                (row.text
                  ? '<span class="postadres-flow__modal-row-label">' +
                    escapeHtml(row.text) +
                    '</span>'
                  : '') +
                '</div>' +
                '<div class="postadres-flow__modal-line-price">' +
                (row.price
                  ? '<strong class="postadres-flow__modal-price-main">' +
                    escapeHtml(row.price) +
                    '</strong>'
                  : '') +
                (row.suffix
                  ? '<span class="postadres-flow__modal-price-suffix">' +
                    escapeHtml(row.suffix) +
                    '</span>'
                  : '') +
                '</div></div>'
              );
            })
            .join('');
        } else if (pkg.modalOptionalLegacy) {
          opt.innerHTML = pkg.modalOptionalLegacy;
        } else {
          opt.innerHTML = '';
        }
        var hasOpt = !!opt.innerHTML.trim();
        if (optTitle) optTitle.hidden = !hasOpt;
        if (opt) opt.hidden = !hasOpt;
      }

      if (note) {
        note.textContent = pkg.modalFooterNote || '';
        note.hidden = !note.textContent.trim();
      }

      if (secOpt) {
        secOpt.hidden = !opt.innerHTML.trim();
      }

      if (optStack) {
        var hasOptInner = opt && !!opt.innerHTML.trim();
        var hasFoot = note && !note.hidden;
        optStack.hidden = !hasOptInner && !hasFoot;
      }

      if (modalCta) modalCta.textContent = pkg.modalCta || config.defaultModalCta || '';
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.classList.add('postadres-flow-modal-open');
      var focusEl = modalClose[0] || modal;
      if (focusEl && focusEl.focus) focusEl.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.classList.remove('postadres-flow-modal-open');
    }

    function syncDeliveryPricing() {
      var pkg = getPackageById(state.packageId);
      var baseEls = qsa(section, '[data-summary-package-price-base]');
      var totalEls = qsa(section, '[data-summary-package-price-total], [data-summary-package-price-total-mobile]');
      var legacyPriceEls = qsa(section, '[data-summary-package-price]');
      var extrasWrap = qs(section, '[data-summary-delivery-extra-rows]');
      var monthlyNoteEl = qs(section, '[data-summary-monthly-note]');
      if (!pkg) return;

      if (!baseEls.length || !totalEls.length) {
        if (legacyPriceEls.length) {
          var legacyAmount = pkg.priceAmount || '';
          legacyPriceEls.forEach(function (el) {
            setSidebarMoneyMarkup(el, legacyAmount);
          });
        }
        return;
      }

      var pkgAmount = pkg.priceAmount || '';
      baseEls.forEach(function (el) {
        setSidebarMoneyMarkup(el, pkgAmount);
      });

      var baseNum = parseEuroNumber(pkgAmount);
      var opts = config.deliveryOptions || [];
      var checkedVals = qsa(section, 'input[name="delivery[]"]:checked').map(function (inp) {
        return String(inp.value || '').trim();
      });

      var addonSum = 0;
      var rows = [];
      checkedVals.forEach(function (val) {
        var o = opts.find(function (x) {
          return String(x.value || '').trim() === val;
        });
        if (!o) return;
        var euro = Number(o.addonEuro) || 0;
        if (euro > 0) addonSum += euro;
        var pd = String(o.priceDisplay || '').trim();
        rows.push({
          label: o.label || '',
          priceStr: pd || (euro > 0 ? formatEuroDutch(euro) : ''),
        });
      });

      var rex = config.repeatableExtras;
      if (rex) {
        if (rex.extraKvk) {
          var kvkList = qs(section, '[data-repeatable-list="extra_kvk"]');
          var nk = kvkList ? qsa(kvkList, '.postadres-flow__repeatable-row').length : 0;
          var eK = Number(rex.extraKvk.perMonthEuro) || 0;
          if (nk > 0 && eK > 0) {
            var sumK = nk * eK;
            addonSum += sumK;
            var lbK = String(rex.extraKvk.label || '').trim() || 'Extra KVK-nummer';
            if (nk > 1) lbK += ' (' + nk + '×)';
            rows.push({ label: lbK, priceStr: formatEuroDutch(sumK) });
          }
        }
        if (rex.extraTrade) {
          var trList = qs(section, '[data-repeatable-list="extra_trade"]');
          var nt = trList ? qsa(trList, '.postadres-flow__repeatable-row').length : 0;
          var eT = Number(rex.extraTrade.perMonthEuro) || 0;
          if (nt > 0 && eT > 0) {
            var sumT = nt * eT;
            addonSum += sumT;
            var lbT = String(rex.extraTrade.label || '').trim() || 'Extra handelsnaam';
            if (nt > 1) lbT += ' (' + nt + '×)';
            rows.push({ label: lbT, priceStr: formatEuroDutch(sumT) });
          }
        }
      }

      if (extrasWrap) {
        if (!rows.length) {
          extrasWrap.innerHTML = '';
          extrasWrap.hidden = true;
        } else {
          extrasWrap.hidden = false;
          extrasWrap.innerHTML = rows
            .map(function (r) {
              return (
                '<div class="postadres-flow__sidebar-row">' +
                '<span class="postadres-flow__sidebar-row-label">' +
                escapeHtml(r.label) +
                '</span><span></span></div>'
              );
            })
            .join('');
          var priceSpans = qsa(extrasWrap, '.postadres-flow__sidebar-row span:last-child');
          rows.forEach(function (r, i) {
            setSidebarMoneyMarkup(priceSpans[i], r.priceStr);
          });
        }
      }

      if (!isNaN(baseNum) && baseNum >= 0) {
        var totalDisplay = formatEuroDutch(baseNum + addonSum);
        totalEls.forEach(function (el) {
          setSidebarMoneyMarkup(el, totalDisplay);
        });
      } else {
        totalEls.forEach(function (el) {
          setSidebarMoneyMarkup(el, pkgAmount);
        });
      }

      if (monthlyNoteEl) {
        var defaultMonthlyNote = monthlyNoteEl.getAttribute('data-default-monthly-note') || '';
        var packageMonthlyNote = String(pkg.priceFootnote || '').trim();
        var baseNote = packageMonthlyNote || defaultMonthlyNote;
        monthlyNoteEl.textContent = applyAddonToEuroValues(baseNote, addonSum);
        monthlyNoteEl.hidden = !String(monthlyNoteEl.textContent || '').trim();
      }
    }

    function syncStep3Sidebar() {
      var loc = getLocationByHandle(state.location);
      var pkg = getPackageById(state.packageId);
      var cityEl = qs(section, '[data-summary-city]');
      var line1El = qs(section, '[data-summary-line1]');
      var line2El = qs(section, '[data-summary-line2]');
      var thumbEl = qs(section, '[data-summary-thumb]');
      var pkgNameEl = qs(section, '[data-summary-package-name]');
      var regBaseEls = qsa(section, '[data-summary-registration-base]');
      var regTotalEls = qsa(section, '[data-summary-registration-total]');
      var onceExtrasWrap = qs(section, '[data-summary-once-extra-rows]');

      if (loc) {
        if (cityEl) cityEl.textContent = loc.city || '';
        if (line1El) line1El.textContent = loc.addressLine1 || '';
        if (line2El) line2El.textContent = loc.addressLine2 || '';
        if (thumbEl) {
          if (loc.image) {
            thumbEl.src = loc.image;
            thumbEl.hidden = false;
          } else {
            thumbEl.hidden = true;
          }
        }
      }
      if (pkg) {
        if (pkgNameEl) pkgNameEl.textContent = pkg.title || '';
        var regText = pkg.sidebarRegistration || pkg.modalRegistrationPlain || '';
        var regNum = parseEuroNumber(regText);
        var extraKvkCount = getFilledExtraKvkCount(section);
        var rex = config.repeatableExtras || {};
        var extraKvkVerificationEuro = Number(rex.extraKvkVerificationEuro) || 86.5;
        var onceRows = [];
        var onceTotal = !isNaN(regNum) ? regNum : 0;
        var onceTotalHasNumber = !isNaN(regNum);
        if (extraKvkCount > 0 && extraKvkVerificationEuro > 0) {
          var extraVerificationSum = extraKvkCount * extraKvkVerificationEuro;
          onceTotal += extraVerificationSum;
          var extraVerificationLabel =
            String((rex.extraKvk && rex.extraKvk.verificationLabel) || '').trim() ||
            'Extra KVK-verificatie';
          if (extraKvkCount > 1) extraVerificationLabel += ' (' + extraKvkCount + '×)';
          onceRows.push({
            label: extraVerificationLabel,
            priceStr: formatEuroDutch(extraVerificationSum),
          });
        }
        var pkgOneTimeRows = pkg.modalOneTimeRows || [];
        pkgOneTimeRows.forEach(function (row) {
          var label = String((row && row.text) || '').trim();
          var sidebarLabel = String((row && row.sidebarLabel) || '').trim();
          var priceRaw = row && row.price != null ? String(row.price).trim() : '';
          if (!label && !priceRaw) return;
          onceRows.push({
            label: sidebarLabel || label || 'Eenmalig extra',
            priceStr: priceRaw,
          });
          var parsed = parseEuroNumber(priceRaw);
          if (!isNaN(parsed)) {
            onceTotal += parsed;
          } else {
            onceTotalHasNumber = false;
          }
        });
        if (onceExtrasWrap) {
          if (!onceRows.length) {
            onceExtrasWrap.innerHTML = '';
            onceExtrasWrap.hidden = true;
          } else {
            onceExtrasWrap.hidden = false;
            onceExtrasWrap.innerHTML = onceRows
              .map(function (r) {
                return (
                  '<div class="postadres-flow__sidebar-row">' +
                  '<span class="postadres-flow__sidebar-row-label">' +
                  escapeHtml(r.label) +
                  '</span><span></span></div>'
                );
              })
              .join('');
            var oncePriceSpans = qsa(onceExtrasWrap, '.postadres-flow__sidebar-row span:last-child');
            onceRows.forEach(function (r, i) {
              setSidebarMoneyMarkup(oncePriceSpans[i], r.priceStr);
            });
          }
        }
        var onceDisplay = regText;
        if (onceTotalHasNumber) onceDisplay = formatEuroDutch(onceTotal);
        regBaseEls.forEach(function (el) {
          setSidebarMoneyMarkup(el, regText);
        });
        regTotalEls.forEach(function (el) {
          setSidebarMoneyMarkup(el, onceDisplay);
        });
      }
      syncDeliveryPricing();
    }

    function syncStep3DeliverySection(pkg) {
      var deliveryAccordion = qs(section, '[data-delivery-accordion]');
      var detailsAccordion = qs(section, '[data-details-accordion]');
      var deliveryInputs = qsa(section, 'input[name="delivery[]"]');
      var opt1PriceEl = qs(section, '[data-delivery-opt1-price]');
      if (!deliveryAccordion || !detailsAccordion) return;

      var pkgTitle = pkg ? String(pkg.title || '').toLowerCase() : '';
      var rawNote = pkg ? String(pkg.deliveryOpt1PriceNote || '').trim() : '';
      var showDelivery = !pkg || pkg.showDeliveryStep !== false;
      deliveryAccordion.hidden = !showDelivery;

      if (!showDelivery) {
        deliveryInputs.forEach(function (inp) {
          inp.checked = false;
          inp.disabled = true;
        });
        deliveryAccordion.open = false;
        detailsAccordion.open = true;
      } else {
        deliveryInputs.forEach(function (inp) {
          inp.disabled = false;
        });
      }

      if (opt1PriceEl) {
        var note = showDelivery ? rawNote : '';
        if (note === '-') note = '';
        if (!note && showDelivery && /professional|business/.test(pkgTitle)) {
          note = '(+ € naar gewicht)';
        }
        opt1PriceEl.hidden = !note;
        opt1PriceEl.textContent = note;
      }

      syncDeliveryPricing();
    }

    function scheduleStep3PricingSync() {
      if (state.step === 3) syncStep3Sidebar();
    }

    section.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !section.contains(t)) return;
      if (t.name !== 'extra_kvk') return;
      if (state.step !== 3) return;
      scheduleStep3PricingSync();
    });

    section.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'delivery[]') return;
      if (!section.contains(t)) return;
      if (state.step !== 3) return;
      syncDeliveryPricing();
    });

    function selectLocationByHandle(handle) {
      var picked = normLocHandle(handle);
      if (!picked) return;
      state.location = picked;
      setStep(2);
    }

    qsa(section, '[data-choose-location]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectLocationByHandle(btn.getAttribute('data-location-handle'));
      });
    });

    qsa(section, '[data-location-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('button, a, input, select, textarea, label')) return;
        selectLocationByHandle(card.getAttribute('data-location-handle'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        selectLocationByHandle(card.getAttribute('data-location-handle'));
      });
    });

    qsa(section, '[data-back-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = parseInt(btn.getAttribute('data-back-step'), 10);
        if (!isNaN(target)) setStep(target);
      });
    });

    qsa(section, '[data-accordion-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = qs(section, '[data-postadres-form]');
        if (form && !validateDeliveryYesNoChoice(form, true)) {
          return;
        }
        moveToDetailsAccordion();
      });
    });

    qsa(section, 'input[type="radio"][name="delivery[]"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var form = qs(section, '[data-postadres-form]');
        if (!form) return;
        validateDeliveryYesNoChoice(form, false);
      });
    });

    qsa(section, '.postadres-flow__accordion summary').forEach(function (summaryEl) {
      summaryEl.addEventListener('click', function (e) {
        if (state.step !== 3 || !isMobileViewport()) return;
        e.preventDefault();
        var accordions = qsa(section, '.postadres-flow__accordion');
        accordions.forEach(function (acc) {
          acc.open = true;
        });
      });
    });

    function openPackageModalById(pid) {
      if (!pid) return;
      state.packageId = pid;
      var pkg = getPackageById(pid);
      fillModal(pkg);
      openModal();
      updateStepperNavigability();
    }

    qsa(section, '[data-open-package-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openPackageModalById(btn.getAttribute('data-package-id'));
      });
    });

    qsa(section, '[data-package-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('button, a, input, select, textarea, label')) return;
        openPackageModalById(card.getAttribute('data-package-id'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        openPackageModalById(card.getAttribute('data-package-id'));
      });
    });

    stepperItems.forEach(function (el) {
      el.addEventListener('click', function () {
        var n = parseInt(el.getAttribute('data-stepper-step'), 10);
        if (!isNaN(n)) tryGoToStep(n);
      });
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        var n = parseInt(el.getAttribute('data-stepper-step'), 10);
        if (!isNaN(n)) tryGoToStep(n);
      });
    });

    modalClose.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', closeModal);
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    if (modalCta) {
      modalCta.addEventListener('click', function () {
        closeModal();
        setStep(3);
      });
    }

    qsa(section, '[data-repeat-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tid = btn.getAttribute('data-repeat-template');
        var targetId = btn.getAttribute('data-repeat-target');
        var tpl = tid ? document.getElementById(tid) : null;
        var list = targetId ? document.getElementById(targetId) : null;
        if (!tpl || !list || !tpl.content || !tpl.content.firstElementChild) return;
        list.appendChild(tpl.content.firstElementChild.cloneNode(true));
        scheduleStep3PricingSync();
      });
    });

    qsa(section, '[data-repeatable-list]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || typeof t.closest !== 'function') return;
        var rm = t.closest('[data-repeat-remove]');
        if (!rm) return;
        e.preventDefault();
        var row = rm.closest('.postadres-flow__repeatable-row');
        if (row) row.remove();
        scheduleStep3PricingSync();
      });
    });

    var form = qs(section, '[data-postadres-form]');
    var sidebarSubmitBtn = qs(section, '[data-sidebar-submit]');
    if (form && sidebarSubmitBtn) {
      sidebarSubmitBtn.addEventListener('click', function () {
        var formSubmitBtn = qs(form, '[type="submit"]');
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(formSubmitBtn || undefined);
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }
    if (form) {
      initStrictContactValidation(form);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validateDeliveryYesNoChoice(form, true)) {
          return;
        }
        var firstNameInput = qs(form, '[name="first_name"]');
        var lastNameInput = qs(form, '[name="last_name"]');
        var emailInput = qs(form, '[name="email"]');
        var phoneInput = qs(form, '[name="phone"]');
        var phoneCountrySelect = qs(form, '[name="phone_country"]');
        var houseNumberInput = qs(form, '[name="house_number"]');
        var postcodeInput = qs(form, '[name="postcode"]');
        var birthDateInput = qs(form, '[name="birth_date"]');
        if (firstNameInput) {
          firstNameInput.value = sanitizeNameValue(firstNameInput.value);
          if (!isValidNameValue(firstNameInput.value)) {
            firstNameInput.setCustomValidity('Vul een geldige voornaam in.');
            firstNameInput.reportValidity();
            return;
          }
          firstNameInput.setCustomValidity('');
        }
        if (lastNameInput) {
          lastNameInput.value = sanitizeNameValue(lastNameInput.value);
          if (!isValidNameValue(lastNameInput.value)) {
            lastNameInput.setCustomValidity('Vul een geldige achternaam in.');
            lastNameInput.reportValidity();
            return;
          }
          lastNameInput.setCustomValidity('');
        }
        var companyNameInput = qs(form, '[name="company_name"]');
        if (companyNameInput) {
          companyNameInput.value = String(companyNameInput.value || '').trim();
          if (!companyNameInput.value) {
            companyNameInput.setCustomValidity('Vul je bedrijfsnaam in.');
            companyNameInput.reportValidity();
            return;
          }
          companyNameInput.setCustomValidity('');
        }
        if (emailInput && !isValidEmailValue(emailInput.value)) {
          emailInput.setCustomValidity('Vul een geldig e-mailadres in.');
          emailInput.reportValidity();
          return;
        }
        if (phoneInput) {
          var phoneMeta = syncPhoneDialPrefix(null, phoneCountrySelect);
          phoneInput.value = sanitizePhoneValue(
            phoneInput.value,
            phoneMeta.dial,
            phoneMeta.iso,
            phoneMeta.dial
          );
          var digits = phoneNationalDigitCount(phoneInput.value, phoneMeta.dial);
          if (digits < 6) {
            phoneInput.setCustomValidity('Vul een geldig telefoonnummer in (minimaal 6 cijfers).');
            phoneInput.reportValidity();
            return;
          }
          phoneInput.setCustomValidity('');
        }
        if (houseNumberInput) {
          houseNumberInput.value = sanitizeHouseNumberValue(houseNumberInput.value);
          if (!houseNumberInput.value) {
            houseNumberInput.setCustomValidity('Vul een geldig huisnummer in.');
            houseNumberInput.reportValidity();
            return;
          }
          houseNumberInput.setCustomValidity('');
        }
        if (postcodeInput) {
          postcodeInput.value = sanitizePostcodeValue(postcodeInput.value);
          if (!isValidPostcode(postcodeInput.value)) {
            postcodeInput.setCustomValidity('Vul een geldige postcode in (bijv. 1234 AB).');
            postcodeInput.reportValidity();
            return;
          }
          postcodeInput.setCustomValidity('');
        }
        if (birthDateInput) {
          var todayIso = getTodayIsoLocal();
          if (!birthDateInput.value) {
            birthDateInput.setCustomValidity('Vul je geboortedatum in.');
            birthDateInput.reportValidity();
            return;
          }
          if (birthDateInput.value && birthDateInput.value > todayIso) {
            birthDateInput.setCustomValidity('Geboortedatum kan niet in de toekomst liggen.');
            birthDateInput.reportValidity();
            return;
          }
          birthDateInput.setCustomValidity('');
        }
        if (!validateAllKvkInputs(form)) {
          return;
        }

        // ---------- Cart submission + checkout redirect ----------
        var fd = new FormData(form);
        var locHandle = normLocHandle(state.location);
        var loc = getLocationByHandle(locHandle) || {};
        var pkg = getPackageById(state.packageId) || {};
        var locationUuid = LOCATION_UUIDS[locHandle] || '';

        // Resolve variant from location + package slug (set in the section schema)
        var packageSlug = String(pkg.packageSlug || '').trim().toLowerCase();
        var variantKey = locHandle + ':' + packageSlug;
        var variantId = VARIANT_IDS[variantKey];

        if (!variantId) {
          console.error('postadres-aanvraag-flow: geen variant gevonden voor', variantKey);
          var msgElEarly = qs(section, '[data-form-message]');
          if (msgElEarly) {
            msgElEarly.hidden = false;
            msgElEarly.textContent =
              'Configuratiefout: er is geen product gekoppeld aan deze combinatie. Neem contact op.';
            msgElEarly.classList.add('is-error');
            msgElEarly.classList.remove('is-success');
          }
          return;
        }

        // Repeatables (multiple inputs share the same name)
        var extraKvkList = fd.getAll('extra_kvk')
          .map(function (v) { return String(v).trim(); })
          .filter(Boolean);
        var extraKvkQuantity = extraKvkList.length;
        var extraTradeList = fd.getAll('extra_trade_name')
          .map(function (v) { return String(v).trim(); })
          .filter(Boolean);

        // Delivery (radio group with name="delivery[]")
        var deliveryValue = String(fd.get('delivery[]') || '');
        var deliveryForwardOption =
          (config.deliveryOptions && config.deliveryOptions[0] && config.deliveryOptions[0].value) ||
          'forward_physical';
        var forwardPhysical = deliveryValue === deliveryForwardOption;
        var deliveryAccordionHidden = (function () {
          var acc = qs(section, '[data-delivery-accordion]');
          return !!(acc && acc.hidden);
        })();

        // Birth date display
        var birthRaw = String(fd.get('birth_date') || '');
        var birthDisplay = birthRaw ? birthRaw.split('-').reverse().join('-') : '';

        var phoneValue = String(fd.get('phone') || '').trim();
        var firstName = String(fd.get('first_name') || '');
        var lastName = String(fd.get('last_name') || '');
        var companyName = String(fd.get('company_name') || '');
        var emailValue = String(fd.get('email') || '');
        var streetValue = String(fd.get('street') || '');
        var houseNumber = String(fd.get('house_number') || '');
        var postcodeValue = String(fd.get('postcode') || '');
        var cityPrivate = String(fd.get('city_private') || '');
        var remarksValue = String(fd.get('remarks') || '');

        var attributes = {
          'Locatie': loc.city || '',
          'Locatie - Adres': [loc.addressLine1, loc.addressLine2].filter(Boolean).join(', '),
          'Locatie - Code': locHandle,
          'Locatie - UUID': locationUuid,
          'Pakket': pkg.title || '',
          'Pakket - ID': state.packageId || '',
          'Pakket - Slug': packageSlug,
          'Post fysiek doorsturen': deliveryAccordionHidden
            ? ''
            : (deliveryValue ? (forwardPhysical ? 'Ja' : 'Nee') : ''),
          'Voornaam': firstName,
          'Achternaam': lastName,
          'Bedrijfsnaam': companyName,
          'KVK-nummer': String(fd.get('kvk_number') || ''),
          'Extra KVK-nummers': extraKvkList.join(', '),
          'Aantal extra KVK-verificaties': extraKvkQuantity ? String(extraKvkQuantity) : '',
          'Extra handelsnamen': extraTradeList.join(', '),
          'E-mailadres': emailValue,
          'Telefoonnummer': phoneValue,
          'Geboortedatum': birthDisplay,
          'Privé - Straat': streetValue,
          'Privé - Huisnummer': houseNumber,
          'Privé - Postcode': postcodeValue,
          'Privé - Plaats': cityPrivate,
        };

        var cleanAttributes = {};
        Object.keys(attributes).forEach(function (k) {
          var v = attributes[k];
          if (v != null && String(v).trim() !== '') cleanAttributes[k] = String(v);
        });

        var btn = qs(form, '[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }
        if (sidebarSubmitBtn) {
          sidebarSubmitBtn.disabled = true;
          sidebarSubmitBtn.setAttribute('aria-busy', 'true');
        }

        var msgEl = qs(section, '[data-form-message]');
        if (msgEl) {
          msgEl.textContent = '';
          msgEl.hidden = true;
        }

        var cartItems = [{
          id: variantId,
          quantity: 1,
          properties: {
            'Pakket': pkg.title || '',
            'Locatie': loc.city || '',
          },
        }];
        if (extraKvkQuantity > 0) {
          cartItems.push({
            id: EXTRA_KVK_VERIFICATION_VARIANT_ID,
            quantity: extraKvkQuantity,
            properties: {
              'Extra KVK-nummers': extraKvkList.join(', '),
              'Pakket': pkg.title || '',
              'Locatie': loc.city || '',
            },
          });
        }

        // 1) Clear existing cart → 2) Add variants → 3) Set attributes + note → 4) Redirect
        fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: cartItems,
            }),
          })
          .then(function (res) {
            if (!res.ok) {
              return res.text().then(function (txt) {
                throw new Error('cart add ' + res.status + ': ' + txt);
              });
            }
            return res.json();
          })
          .then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                attributes: cleanAttributes,
                note: remarksValue,
              }),
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('cart update ' + res.status);
            return res.json().catch(function () { return {}; });
          })
          .then(function () {
            var params = new URLSearchParams();
            if (emailValue) params.set('checkout[email]', emailValue);
            if (firstName) params.set('checkout[shipping_address][first_name]', firstName);
            if (lastName) params.set('checkout[shipping_address][last_name]', lastName);
            if (companyName) params.set('checkout[shipping_address][company]', companyName);
            var streetLine = (streetValue + ' ' + houseNumber).trim();
            if (streetLine) params.set('checkout[shipping_address][address1]', streetLine);
            if (postcodeValue) params.set('checkout[shipping_address][zip]', postcodeValue);
            if (cityPrivate) params.set('checkout[shipping_address][city]', cityPrivate);
            params.set('checkout[shipping_address][country]', 'Netherlands');
            if (phoneValue) params.set('checkout[shipping_address][phone]', phoneValue);
            var qsStr = params.toString();
            window.location.href = '/checkout' + (qsStr ? ('?' + qsStr) : '');
          })
          .catch(function (err) {
            console.error(err);
            if (msgEl) {
              msgEl.hidden = false;
              msgEl.textContent =
                (config.submit && config.submit.errorMessage) ||
                'Er ging iets mis. Probeer het later opnieuw.';
              msgEl.classList.add('is-error');
              msgEl.classList.remove('is-success');
            }
            if (btn) {
              btn.disabled = false;
              btn.removeAttribute('aria-busy');
            }
            if (sidebarSubmitBtn) {
              sidebarSubmitBtn.disabled = false;
              sidebarSubmitBtn.removeAttribute('aria-busy');
            }
          });
      });
    }

    initPhoneCountryRow(section, config);
    initMobileStep3Sheet();

    setStep(1);
  }

  function boot() {
    initPostadresSidebarHeaderSync();
    qsa(document, '.postadres-flow').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();